import React from "react";
import { Navigate, Route, Routes } from "react-router";
import { authRoutes, publicRoutes } from "./router.link";
import Feature from "../feature";
import AuthFeature from "../authFeature";
import Login from "../auth/login/login";
import Login2 from "../auth/login/login-2";
import Login3 from "../auth/login/login-3";
import  Home  from "../index";
import SetSchoolTitle from "../SetSchoolTitle";
import PayUFailure from "../auth/PayuPaymnt/PayUFailure";
import PayUPayment from "../auth/PayuPaymnt/PayUPayment";
import PayUSuccess from "../auth/PayuPaymnt/PayUSuccess";

const ALLRoutes: React.FC = () => {
  return (
    <>
    <SetSchoolTitle />
      <Routes>
        <Route path="/"  element={<Home/>} />
        <Route element={<Feature />}>
          {publicRoutes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>

        <Route element={<AuthFeature />}>
          {authRoutes.map((route, idx) => (
            <>
            <Route path={route.path} element={route.element} key={idx} />
            <Route path="/pay-u-payment" element={<PayUPayment />} />
             <Route path="/payment/success" element={<PayUSuccess />} />
              <Route path="/payment/failure" element={<PayUFailure />} />
              </>
          ))}
        </Route>
      </Routes>
    </>
  );
};

export default ALLRoutes;
